import { createSlice } from "@reduxjs/toolkit";

const initialUserState = {
    roadmaps: null,
};

const roadmapsSlice = createSlice({
    name: "All Roadmap",
    initialState: initialUserState,
    reducers: {
        storeRoadmap(state, action) {
            state.roadmaps = action.payload;
        },
    },
});

export const roadmapsActions = roadmapsSlice.actions;

export default roadmapsSlice.reducer;